<!-- version 2021/05/20 -->
<template>
  <div class="d-flex justify-content-between l_rwd">
    <app-label-text class="mb-0" :title="title"></app-label-text>
    <app-normal-text class="mr-3" :text="text" :ellipsis="ellipsis"></app-normal-text>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    text: { type: String, default: '' },
    ellipsis: { type: Boolean, default: false },
  },
};
</script>

<style lang="sass" scoped>
label
  min-width: 120px
</style>
